import { createAsyncThunk } from '@reduxjs/toolkit';
import { NotificationActions } from './NotificationSlice';
import { NotificationListResponse } from 'src/shared/types/src/lib/notification.types';
import {
  fetchNotificationsData,
  fetchNotificationUnReadCountData,
  markAsRead,
} from 'src/shared/services/src/lib/notification';
import { RootState } from 'src/shared/types/src';

export const updateNotificationLoader = createAsyncThunk(
  'updateNotificationLoader',
  async (payload: { notificationLoading: boolean }, { dispatch }) => {
    dispatch(
      NotificationActions.setNotificationsLoader({
        isLoading: payload.notificationLoading,
      })
    );
  }
);

export const updateNotificationPaginatedLoader = createAsyncThunk(
  'updateNotificationPaginatedLoader',
  async (payload: { paginatedLoading: boolean }, { dispatch }) => {
    dispatch(
      NotificationActions.setNotificationsPaginatedLoader({
        paginatedLoading: payload.paginatedLoading,
      })
    );
  }
);

export const fetchNotifications = createAsyncThunk(
  'fetchNotifications',
  async ({ page }: { page: number }, { dispatch }) => {
    try {
      if (page === 1) {
        await dispatch(NotificationActions.resetNotificationState(null));
        dispatch(updateNotificationLoader({ notificationLoading: true }));
      } else {
        dispatch(updateNotificationPaginatedLoader({ paginatedLoading: true }));
      }
      const response = await fetchNotificationsData(page);
      const notificationsResponse = response as NotificationListResponse;
      if (notificationsResponse) {
        dispatch(
          NotificationActions.appendNotifications({
            list: notificationsResponse.notifications,
            pagination: notificationsResponse.pagination,
          })
        );
      }
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    } finally {
      dispatch(updateNotificationLoader({ notificationLoading: false }));
      dispatch(updateNotificationPaginatedLoader({ paginatedLoading: false }));
    }
  }
);

export const fetchNotificationUnReadCount = createAsyncThunk(
  'fetchNotificationUnReadCount',
  async (_, { dispatch }) => {
    try {
      const response = await fetchNotificationUnReadCountData();
      const notificationsCount = response.count as number;
      if (notificationsCount) {
        dispatch(
          NotificationActions.setUnreadCount({
            unReadCount: notificationsCount,
          })
        );
      }
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  'markNotificationAsRead',
  async ({ id }: { id: number }, { dispatch }) => {
    try {
      const response = await markAsRead(id);
      if (response) {
        dispatch(NotificationActions.updateReadStatus({ id }));
        const unreadCount = response?.data?.count;
        if ((unreadCount && !isNaN(unreadCount)) || unreadCount === 0) {
          dispatch(
            NotificationActions.setUnreadCount({ unReadCount: unreadCount })
          );
        }
      }
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    }
  }
);
